import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../images/marriage.jpg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { AppContext } from "../context/AppContext";
import ReCAPTCHA from "react-google-recaptcha";
import Cookies from 'js-cookie';

export default function Signup() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    StreetAddress: "",
    password: "",
    confirmPassword: "",
    role: "user",
    gender: "",
  });
  const { t } = useTranslation();
  const {
    siteKey,
  } = useContext(AppContext);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [captchaValue, setcaptchaValue] = useState(null);
  const [errors, setErrors] = useState({
    firstName: "",
    lastName: "",
    email: "",
    StreetAddress: "",
    password: "",
    confirmPassword: "",
    role: "",
    gender: "",
  });

  const navigate = useNavigate();

  const handleTogglePasswordVisibility = (field) => {
    if (field === "password") {
      setPasswordVisible(!passwordVisible);
    } else if (field === "confirmPassword") {
      setConfirmPasswordVisible(!confirmPasswordVisible);
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();

    setLoading(true);
    const {
      firstName,
      lastName,
      email,
      password,
      confirmPassword,
      role,
      StreetAddress,
      gender,
    } = formData;

    // Perform form validation
    let formErrors = {};

    if (!/^[a-zA-Z\s]+$/.test(firstName)) {
      formErrors.firstName = t(
        "First name must contain only letters and spaces."
      );
    }

    if (!/^[a-zA-Z\s]+$/.test(lastName)) {
      formErrors.lastName = t(
        "Last name must contain only letters and spaces."
      );
    }

    if (!/\S+@\S+\.\S+/.test(email)) {
      formErrors.email = t("Please enter a valid email address.");
    }
    if (StreetAddress.length < 2) {
      formErrors.StreetAddress = t("Address must not be empty");
    }

    if (password.length < 6) {
      formErrors.password = t("Password must be at least 6 characters long.");
    } else if (!/[A-Z]/.test(password) || !/\d/.test(password)) {
      formErrors.password = t(
        "Password must contain at least one uppercase letter and one number."
      );
    }

    if (password !== confirmPassword) {
      formErrors.confirmPassword = t("Passwords do not match.");
    }
    if (role === null) {
      formErrors.role = "Please select a role.";
    }
    if (!gender) {
      formErrors.gender = "Please select a gender.";
    }
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      setLoading(false);
      return;
    }

    // If no errors, proceed with signup
    try {
      const response = await fetch(
        `${process.env.REACT_APP_ADDRESS}/users/signup`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        setLoading(false);
        setSuccess(true);

        Cookies.set("Recentuser", formData.email);
      } else {
        if (response.status === 409) {
          setLoading(false);
          setErrors({ ...errors, email: t("User already exists.") });
        } else {
          setLoading(false);
          setErrors({ ...errors, general: t("Internal server error 😞") });
        }
      }
    } catch (error) {
      setLoading(false);
      setErrors({ ...errors, general: t("Internal server error 😞") });
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    // Clear specific error when user starts typing again
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  useEffect(() => {}, [errors]);

  return (
    <>
      <div className="flex min-h-full flex-1">
        <div className="flex flex-1 flex-col justify-center px-4 py-5 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            {loading ? (
              <div className="flex items-center justify-center">
                <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-pink-600"></div>
              </div>
            ) : success ? (
              <div>
                <div className="text-green-600 font-semibold text-2xl text-center mb-24">
                  {t("Signup successful!")}
                </div>
                <button
                  onClick={() => navigate("/verifyEmail", { replace: true })}
                  className="flex w-full justify-center rounded-md bg-pink-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                >
                  {t("Verify Email.")}
                </button>
              </div>
            ) : (
              <>
                <div>
                  <h2 className="text-2xl font-bold leading-9 tracking-tight text-gray-900 mb-4">
                    {t("Sign up to your Hayya account")}
                  </h2>
                </div>
                <div className="mt-0">
                  <div>
                    <form onSubmit={handleSignup} className="space-y-6">
                      <div>
                        <label
                          htmlFor="firstName"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          {t("First name")}
                        </label>
                        <div className="mt-0">
                          <input
                            id="firstName"
                            name="firstName"
                            type="text"
                            autoComplete="given-name"
                            required
                            value={formData.firstName}
                            onChange={handleInputChange}
                            className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                          />
                        </div>
                        {errors.firstName && (
                          <p className="text-red-600 text-sm mt-1">
                            {errors.firstName}
                          </p>
                        )}
                      </div>

                      <div>
                        <label
                          htmlFor="lastName"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          {t("Last name")}
                        </label>
                        <div className="mt-0">
                          <input
                            id="lastName"
                            name="lastName"
                            type="text"
                            autoComplete="family-name"
                            required
                            value={formData.lastName}
                            onChange={handleInputChange}
                            className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                          />
                          {errors.lastName && (
                            <p className="text-red-600 text-sm mt-1">
                              {errors.lastName}
                            </p>
                          )}
                        </div>
                      </div>

                      <div>
                        <label
                          htmlFor="email"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          {t("Email address")}
                        </label>
                        <div className="mt-0">
                          <input
                            id="email"
                            name="email"
                            type="email"
                            autoComplete="email"
                            required
                            value={formData.email}
                            onChange={handleInputChange}
                            className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                          />
                          {errors.email && (
                            <p className="text-red-600 text-sm mt-1">
                              {errors.email}
                            </p>
                          )}
                        </div>
                      </div>

                      <div>
                        <label
                          htmlFor="gender"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          {t("Gender")}
                        </label>
                        <div className="mt-2 flex items-center space-x-4">
                          <div className="flex items-center">
                            <input
                              id="male"
                              name="gender"
                              type="radio"
                              value="male"
                              checked={formData.gender === "male"}
                              onChange={handleInputChange}
                              className="h-4 w-4 text-pink-600 border-gray-300 focus:ring-pink-600"
                            />
                            <label
                              htmlFor="male"
                              className="ml-2 block text-sm font-medium text-gray-900"
                            >
                              {t("Male")}
                            </label>
                          </div>
                          <div className="flex items-center">
                            <input
                              id="female"
                              name="gender"
                              type="radio"
                              value="female"
                              checked={formData.gender === "female"}
                              onChange={handleInputChange}
                              className="h-4 w-4 text-pink-600 border-gray-300 focus:ring-pink-600"
                            />
                            <label
                              htmlFor="female"
                              className="ml-2 block text-sm font-medium text-gray-900"
                            >
                              {t("Female")}
                            </label>
                          </div>
                        </div>
                        {errors.gender && (
                          <p className="text-red-600 text-sm mt-1">
                            {errors.gender}
                          </p>
                        )}
                      </div>

                      <div>
                        <label
                          htmlFor="StreetAddress"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          {t("Street Address")}
                        </label>
                        <div className="mt-0">
                          <input
                            id="StreetAddress"
                            name="StreetAddress"
                            type="text"
                            autoComplete="StreetAddress"
                            required
                            value={formData.StreetAddress}
                            onChange={handleInputChange}
                            className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                          />
                          {errors.StreetAddress && (
                            <p className="text-red-600 text-sm mt-1">
                              {errors.StreetAddress}
                            </p>
                          )}
                        </div>
                      </div>

                      <div>
                        <label
                          htmlFor="password"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          {t("Password")}
                        </label>
                        <div className="mt-0 relative">
                          <input
                            id="password"
                            name="password"
                            type={passwordVisible ? "text" : "password"}
                            autoComplete="new-password"
                            required
                            value={formData.password}
                            onChange={handleInputChange}
                            className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                          />

                          <span
                            onClick={() =>
                              handleTogglePasswordVisibility("password")
                            }
                            className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                          >
                            {passwordVisible ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="w-6 h-6"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                                />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="w-6 h-6"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                                />
                              </svg>
                            )}
                          </span>
                        </div>
                        {errors.password && (
                          <p className="text-red-600 text-sm pt-1">
                            {errors.password}
                          </p>
                        )}
                      </div>

                      <div>
                        <label
                          htmlFor="confirmPassword"
                          className="block text-sm font-medium leading-6 text-gray-900"
                        >
                          {t("Re-type password")}
                        </label>

                        <div className="mt-2 relative">
                          <input
                            id="confirmPassword"
                            name="confirmPassword"
                            type={confirmPasswordVisible ? "text" : "password"}
                            autoComplete="new-password"
                            required
                            value={formData.confirmPassword}
                            onChange={handleInputChange}
                            className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-pink-600 sm:text-sm sm:leading-6"
                          />

                          <span
                            onClick={() =>
                              handleTogglePasswordVisibility("confirmPassword")
                            }
                            className="absolute inset-y-0 right-0 pr-3 flex items-center cursor-pointer"
                          >
                            {confirmPasswordVisible ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="w-6 h-6"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                                />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="w-6 h-6"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                                />
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                                />
                              </svg>
                            )}
                          </span>
                        </div>

                        {errors.confirmPassword && (
                          <p className="text-red-600 text-sm mt-1">
                            {errors.confirmPassword}
                          </p>
                        )}
                      </div>
                      <div>
                        <ReCAPTCHA
                   sitekey={siteKey}
                          onChange={((val) => setcaptchaValue(val))}
                        />
                      </div>
                      <div>
                        <button
                        disabled={!captchaValue}
                          type="submit"
                          className="flex w-full justify-center rounded-md bg-pink-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-pink-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600"
                        >
                          {t("Sign up")}
                        </button>
                      </div>

                    </form>
                  </div>

                  <div className="mt-5">
                    <div className="relative">
                      <div
                        className="absolute inset-0 flex items-center"
                        aria-hidden="true"
                      >
                        <div className="w-full border-t border-gray-200" />
                      </div>
                      <div className="relative flex justify-center text-sm font-medium leading-6">
                        <span className="bg-white px-6 text-gray-900">
                          {t("Or continue with")}
                        </span>
                      </div>
                    </div>

                    <div className="mt-4">
                      <a
                        href="#"
                        className="flex w-full items-center justify-center gap-3 rounded-md bg-white px-3 py-1.5 text-black border border-gray-300 focus:outline-none focus-visible:outline-none focus-visible:border-black focus-visible:border-opacity-100"
                      >
                        <img
                          width="48"
                          height="48"
                          src="https://img.icons8.com/color/48/google-logo.png"
                          alt="google-logo"
                        />
                        <span className="text-sm font-semibold leading-6">
                          {t("Google")}
                        </span>
                      </a>
                      <div className="mt-2 text-gray-500 text-xs text-center">
                        {t(
                          "By clicking the Sign up button, you are creating a Hayya account and you agree to"
                        )}{" "}
                        <Link
                          to="/TermsOfUse"
                          className="ml-1 underline hover:text-gray-700 focus:outline-none focus:underline"
                        >
                          Hayya&apos;s {t("Terms of Use")}
                        </Link>{" "}
                        and{" "}
                        <Link
                          to="/PrivacyPolicy"
                          className="ml-1 underline hover:text-gray-700 focus:outline-none focus:underline"
                        >
                          {t("Privacy Policy")}
                        </Link>
                        .
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="relative hidden min-w-screen min-h-screen flex-1 lg:block">
          <img
            className="absolute inset-0 w-full h-full object-cover"
            src={logo}
            alt="img"
          />
        </div>
      </div>
    </>
  );
}
